import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Swiper from 'swiper/js/swiper.js';
import debounce from 'lodash.debounce';

import Container from 'partials/Container';
import GridElement from 'partials/GridElement';
import Navigation from './Navigation';
import Filters from './Filters/TagFilters';
import SeasonFilters from './Filters/SeasonFilters';
import tagObjectArray from './Filters/SwitchTags';
import Card from './Card';
import MobileGlider from './MobileGlider';
import { getSeason } from './HandleDate';

import Sun from 'icons/SunIcon';
import Snowflake from 'icons/SnowflakeIcon';
import NorthernLights from 'icons/NorthernLightsIcon';
import Arrow from 'icons/ArrowIcon';
import Media, { ScreenWidth } from 'css/Media';

export class Glider extends Component {

    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            isMobile: false,
            filterOpen: false,
            tagLength: 0,
        };
        this.swiperRef = React.createRef();
    }

    componentWillMount() {
        this.checkScreenSize();
    }

    componentDidMount() {
        window.addEventListener('resize', debounce(() => this.checkScreenSize()),500);
        if(this.props.data && this.props.data.length) {
            this.setState({data: this.props.data},() => this.initSwiper())
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({data: this.props.data},() => this.initSwiper())
        }
      }

    componentWillUnmount() {
        window.removeEventListener('resize', this.checkScreenSize);
    }

    initSwiper = () => {
        this.swiper = new Swiper(this.swiperRef.current, {
            slidesPerView: 'auto',
            allowTouchMove: false,
            loop: this.state.data.length > 2 ? true : false,
            loopedSlides: this.state.data.length > 2 ? this.state.data.length : 0,
            centeredSlides: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            init: false,
        })
        this.swiper.on('init', () => {
            this.swiper.allowSlidePrev = false
        })
        this.swiper.on('slideChange', () => {
            this.swiper.allowSlidePrev = this.swiper.realIndex == 0 ? false : true;
            this.swiper.allowSlideNext = this.swiper.realIndex == this.state.data.length - 2 ? false : true;
            this.setState({active: this.swiper.realIndex});
        })
        !this.state.isMobile ? this.swiper.init() : null;
        this.handleTags();
    };

    checkScreenSize() {
        let isMobile = true;
        let isHuge = false;

        if(ScreenWidth.greaterThan('s')) {
            isMobile = false;
        }
        if(window.innerWidth >= 1800 ) {
            isHuge = true;
        }
        this.setState({isMobile: isMobile, isHuge: isHuge});
    }

    //Filter by tags when sorting activities by season
    handleFilter(tag) {
        this.swiper.destroy();
        if(tag === 'all') {
            this.setState({data: this.props.data},() => this.initSwiper())
        } else {
            let filtered = this.props.data.filter(activity => activity.acf.tags.includes(tag));
            this.setState({data: filtered},() => this.initSwiper());
        }
    }

    handleSeasonFilter(season) {
        if(this.swiper && this.swiper.initialized){
            this.swiper.destroy();
        }
        this.props.handleSeasonFilter(season);
    }

    handleTags = () => {
        let caseArr = [];
        let tagArr = [];

        this.state.data.map(item => {
            item.acf.tags.map(tag => {
                if(!caseArr.includes(tag) && tagObjectArray.filter(item => item.value === tag).length > 0) {
                    tagArr.push(tagObjectArray.filter(item => item.value === tag)[0]);
                    caseArr.push(tag);
                }
                return null;
            })
            return null;
        })

        let flatArr = tagArr.flat();

        if(this.props.season === 'northern_lights') {
            this.setState({
                tags: flatArr.filter(item => item.value !== 'northern_lights'),
                tagLength: flatArr.length,
        })
        } else {
            this.setState({
                tags: flatArr,
                tagLength: flatArr.length,
            });
        }
    }

    render() {
        const { active, isMobile, tagLength, data, } = this.state;
        const {
            title,
            icon,
            nav,
            filter,
            season,
            seasons,
            seasonOverride } = this.props;

            if(!isMobile) {
                if(data && data.length) {
                    return (
                        <Wrapper className={this.props.className}>
                            {season &&
                                <Container grid>
                                    <GridElement
                                        colStart={3}
                                        colEnd={13}
                                    >
                                        <p>{season !== 'all' ? getSeason(season) : null}</p>
                                    </GridElement>
                                </Container>
                            }
                            <Container grid>
                                <GridElement
                                    colStart={1}
                                    colEnd={2}
                                    rowStart={1}
                                    align="center"
                                >
                                    {icon &&
                                        <StyledIcon>
                                            { icon === 'sun' ? <Sun /> : icon === 'snow' ? <Snowflake /> : icon === 'northern_lights' ? <NorthernLights /> : null }
                                        </StyledIcon>
                                    }
                                </GridElement>
                                <GridElement
                                    colStart={icon ? 3 : 1}
                                    colEnd={13}
                                    rowStart={1}
                                >
                                    <h1>{title}</h1>
                                </GridElement>
                                { tagLength > 0 || seasons ?
                                    <GridElement
                                        colStart={tagLength > 8 ? 3 : 7}
                                        colEnd={22}
                                        rowStart={tagLength > 8 ? 2 : 1}
                                        align="center"
                                    >
                                        { nav &&
                                            <Navigation
                                                data={data}
                                                active={active}
                                            />
                                        }
                                        { filter && data.length &&
                                            <Filters
                                                data={data}
                                                active={active}
                                                season={season}
                                                handleFilter={tag => this.handleFilter(tag)}
                                                isLong={tagLength > 8}
                                            />
                                        }
                                        { seasons && data.length &&
                                            <SeasonFilters
                                                data={data}
                                                active={active}
                                                season={season}
                                                seasonOverride={seasonOverride}
                                                handleSeasonFilter={season => this.handleSeasonFilter(season)}
                                            />
                                        }
                                    </GridElement>
                                : null}
                            </Container>

                            { !isMobile &&
                                <Container grid>
                                    <PagGridElement
                                        colStart={3}
                                        colEnd={8}
                                        colSpan
                                    >
                                        {data.length > 2 &&
                                            <Pagination>
                                                <ArrowWrapper back className="swiper-button-prev" disabled={active === 0}>
                                                    <Arrow />
                                                </ArrowWrapper>
                                                <ArrowWrapper className="swiper-button-next" disabled={active === (data.length - 2)}>
                                                    <Arrow />
                                                </ArrowWrapper>
                                            </Pagination>
                                        }
                                    </PagGridElement>
                                </Container>
                            }
                            <Container bleedRight>
                                    <div className="swiper-container" ref={this.swiperRef}>
                                        <div className="swiper-wrapper">
                                            { data.map(item =>
                                                <div className="swiper-slide" key={item.id}>
                                                    <Card item={item} />
                                                </div>
                                            )}
                                            { data.length > 2 ?
                                                <div className="swiper-slide"></div>
                                            : null}
                                            { data.length > 2 ?
                                                <div className="swiper-slide"></div>
                                            : null}
                                        </div>

                                    </div>
                            </Container>
                        </Wrapper>
                    )
                } else return null;
            } else if (isMobile) {
                return (
                    <MobileGlider
                        data={data}
                        title={title}
                        icon={icon}
                        nav={nav}
                        filter={filter}
                        season={season}
                        seasons={seasons}
                        seasonOverride={seasonOverride}
                        handleSeasonFilter={this.props.handleSeasonFilter}
                    />
                )
            } else return null;
    }
}

export default Glider;

const Wrapper = styled.section`
    user-select: none;

    ${Media.greaterThan('s')`
        padding-bottom: ${props => props.theme.spacing.blockXL};
    `}

    .swiper-container {
        display: flex;
        overflow-x: hidden;
        .swiper-wrapper {
            display: flex;
            align-items: center;
            .swiper-slide {
                display: flex;
                flex-direction: column;
                width: 73.2309231vw;
                color : black;
                z-index: 1000;
                padding-right: 7.077vw;

                a {
                    color: ${props => props.theme.colors.text};
                }

                ${Media.greaterThan('s')`
                    flex-direction: row;
                    width: 40.4166666666vw;
                    padding-right: 2.638888888888889vw;
                `}

                ${Media.greaterThan('xl')`
                    max-width: 807.92px;
                `}
            }
        }
        ${Media.greaterThan('s')`
            margin-left: 8.611%;
        `}

        ${Media.greaterThan('xl')`
            margin-left: calc(18 * 8.611px);
        `}
    }
`

const StyledIcon = styled.div`
    svg {
        width: 100%;
        height: 100%;
    }
`

const PagGridElement = styled(GridElement)`
    min-height: 146px;
`

const Pagination = styled.div`
    display: flex;
    padding: ${props => props.theme.spacing.elementS} 0;
`

const ArrowWrapper = styled.div`
    cursor: pointer;

    svg {
        transition: .1s ease;

        ${props => props.back && css`
            margin-right: ${props => props.theme.spacing.contentL};
            transform: rotate(180deg);
        `}
    }

    ${props => props.disabled && css`
        cursor: auto;
        
        svg {
            fill: ${props => props.theme.colors.input};
        }
    `}

    &:hover {
        ${props => !props.disabled && css`
            &::after {
                position: absolute;
                content: '';
                bottom: 0;
                left: 0;
                width: 27.453px;
                height: 2px;
                background-color: ${props => props.theme.colors.text};
            }
        `}
    }
`
